import React from "react";
import { ReactComponent as CarousleUndeline } from "../../assests/carousleUndeline.svg";
import prizeStar from "../../assests/prizeStar.png";

function PrizeWithImage({ heading, prizeDetails, hexCode, scrollRef }) {
  var coverStyle = {
    background: `linear-gradient(81.11deg, rgba(86, 86, 86, 0.4) 25.51%, rgba(21, 21, 21, 0.4) 74.24%) `,
  };
  var linkStyle = { color: hexCode };

  return (
    <div
      className=" h-[194px] w-[320px] shrink-0 flex-grow "
      style={coverStyle}
      ref={scrollRef}
    >
      <div className="pt-[20px] px-[20px]">
        <p className="text-small mb-[20px]">{heading}</p>
        <div className=" flex justify-between items-start w-[100%]  mb-[9px]">
          {prizeDetails?.image?.map((obj, index) => {
            return (
              <div className="flex flex-col gap-[7px] items-center justify-center w-[25%] text-center relative">
                {index === 0 && (
                  <img
                    src={prizeStar}
                    className="absolute top-[-5px] right-0 "
                  />
                )}
                <div className=" w-[60px] h-[60px] ">
                  <img src={obj?.fileUrl} className="h-[100%] object-contain" />
                </div>
                <p
                  className={`text-smallest2 w-[100%] uppercase whitespace-nowrap ${
                    index == 0 ? "text-[#fffff]" : "text-[#B1B1B1]"
                  }`}
                >
                  {obj?.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <CarousleUndeline
        style={{ width: "100%", height: "auto", color: hexCode }}
      />
    </div>
  );
}

export default PrizeWithImage;
